import { Box, Flex, RadioGroup, Text } from "@radix-ui/themes";
import { useOAuthForm } from "../../OAuthFormContext";

export function AppleWebSecretMethod() {
  const { appleWebMethod, setAppleWebMethod } = useOAuthForm();
  return (
    <Box>
      <Text size="2" weight="medium" mb="1">
        Client secret method
      </Text>
      <RadioGroup.Root
        value={appleWebMethod}
        onValueChange={(v) => setAppleWebMethod(v as "p8" | "jwt")}
      >
        <Flex direction="column" gap="1">
          <RadioGroup.Item value="p8">
            <Text size="2">.p8 self-signing (recommended)</Text>
          </RadioGroup.Item>
          <RadioGroup.Item value="jwt">
            <Text size="2">Static client_secret JWT</Text>
          </RadioGroup.Item>
        </Flex>
      </RadioGroup.Root>
      <Text size="1" color="gray" mt="1" style={{ display: "block" }}>
        Apple client_secrets max out at 6 months. Self-signing means we mint
        one on each token exchange — no rotation needed.
      </Text>
    </Box>
  );
}
